// GroupedNestedTableModernized.jsx
import React, { useMemo, useState } from "react";
import "../styles/GroupedNestedTable.scss";

const GroupedNestedTable = ({ data }) => {
  // const [selectedRows, setSelectedRows] = useState([]);
  const [filters] = useState({});
  const [sortConfig] = useState({ key: null, direction: "asc" });

  const allProjects = useMemo(() => {
    const projectSet = new Set();
    data.forEach((row) => {
      row.Projects.forEach((proj) => {
        Object.keys(proj).forEach((key) => {
          if (key !== "name") {
            projectSet.add(`${proj.name}__${key}`);
          }
        });
      });
    });
    return Array.from(projectSet);
  }, [data]);

  // const handleSelectAll = (e) => {
  //   setSelectedRows(e.target.checked ? data.map((row) => row.resourceName) : []);
  // };

  // const handleSelectRow = (resourceName) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(resourceName)
  //       ? prev.filter((name) => name !== resourceName)
  //       : [...prev, resourceName]
  //   );
  // };

  // const handleFilterChange = (key, value) => {
  //   setFilters((prev) => ({ ...prev, [key]: value }));
  // };

  // const handleSort = (key) => {
  //   setSortConfig((prev) => ({
  //     key,
  //     direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
  //   }));
  // };

  const filteredData = useMemo(() => {
    return data.filter((row) => {
      return Object.entries(filters).every(([key, value]) => {
        return row[key]?.toString().toLowerCase().includes(value.toLowerCase());
      });
    });
  }, [filters, data]);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    const sorted = [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (typeof aVal === "number" && typeof bVal === "number") {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }
      return sortConfig.direction === "asc"
        ? aVal?.toString().localeCompare(bVal?.toString())
        : bVal?.toString().localeCompare(aVal?.toString());
    });
    return sorted;
  }, [filteredData, sortConfig]);

  const groupByProject = useMemo(() => {
    const map = {};
    data.forEach((row) => {
      map[row.resourceName] = {};
      row.Projects.forEach((proj) => {
        Object.entries(proj).forEach(([key, val]) => {
          if (key !== "name") {
            map[row.resourceName][`${proj.name}__${key}`] = val;
          }
        });
      });
    });
    return map;
  }, [data]);

  const projectHeaders = useMemo(() => {
    const headers = {};
    allProjects.forEach((fullKey) => {
      const [project, type] = fullKey.split("__");
      if (!headers[project]) headers[project] = [];
      headers[project].push(type);
    });
    return headers;
  }, [allProjects]);

  const renderGroupHeaders = () => (
    <tr>
      {Object.entries(projectHeaders).map(([proj, types]) => (
        <th key={proj} colSpan={types.length} className="group-header">
          {proj}
        </th>
      ))}
    </tr>
  );

  const renderSubHeaders = () => (
    <tr>
      {Object.entries(projectHeaders).map(([proj, types]) => (
        types.map((type) => (
          <th key={`${proj}__${type}`} className="sortable">
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </th>
        ))
      ))}
    </tr>
  );

  const renderRows = () => (
    sortedData.map((row, idx) => (
      <tr key={idx}>
        <td>{row.resourceName}</td>
        {allProjects.map((key) => (
          <td key={key}>{groupByProject[row.resourceName]?.[key] ?? '-'}</td>
        ))}
      </tr>
    ))
  );

  return (
    <div className="grouped-table-wrapper">
      <table className="grouped-table">
        <thead>
          {renderGroupHeaders()}
          {renderSubHeaders()}
        </thead>
        <tbody>{renderRows()}</tbody>
      </table>
    </div>
  );
};

export default GroupedNestedTable;
